export default __webpack_public_path__ + "static/media/learose-768w.e11012a1.webp";